import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { FileText, Clock, Award, TrendingUp, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StudentTests = () => {
  const navigate = useNavigate();
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('studentToken');
    if (!token) {
      navigate('/student/login');
      return;
    }
    fetchTests();
  }, []);

  const fetchTests = async () => {
    try {
      const response = await fetch(`${API_URL}/api/tests`);
      const data = await response.json();
      setTests(data);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="bg-gradient-to-b from-red-50 to-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-4">
            Test Series
          </h1>
          <p className="text-xl text-gray-600 text-center">
            Practice with mock tests and track your performance
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          {loading ? (
            <div className="text-center py-12">
              <Loader2 className="animate-spin mx-auto text-red-600" size={48} />
            </div>
          ) : tests.length === 0 ? (
            <Card>
              <CardContent className="text-center py-12">
                <FileText className="mx-auto text-gray-400 mb-4" size={48} />
                <p className="text-gray-600">No tests available yet</p>
              </CardContent>
            </Card>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {tests.map((test) => (
                <Card key={test.id} className="hover:shadow-xl transition-shadow">
                  <CardHeader className="bg-gradient-to-r from-red-50 to-red-100">
                    <span className="px-3 py-1 bg-red-600 text-white rounded-full text-xs font-medium w-fit mb-2">
                      {test.course_category}
                    </span>
                    <CardTitle className="text-xl">{test.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="p-6 space-y-4">
                    <p className="text-sm text-gray-600">{test.description}</p>
                    
                    <div className="space-y-2 text-sm">
                      <div className="flex items-center justify-between py-2 border-b">
                        <span className="text-gray-600">Subject:</span>
                        <span className="font-medium">{test.subject}</span>
                      </div>
                      <div className="flex items-center justify-between py-2 border-b">
                        <span className="text-gray-600">Questions:</span>
                        <span className="font-medium">{test.question_count}</span>
                      </div>
                      <div className="flex items-center justify-between py-2 border-b">
                        <span className="text-gray-600 flex items-center">
                          <Clock className="mr-2" size={14} />Duration:
                        </span>
                        <span className="font-medium">{test.duration_minutes} mins</span>
                      </div>
                      <div className="flex items-center justify-between py-2 border-b">
                        <span className="text-gray-600 flex items-center">
                          <Award className="mr-2" size={14} />Total Marks:
                        </span>
                        <span className="font-medium">{test.total_marks}</span>
                      </div>
                      <div className="flex items-center justify-between py-2">
                        <span className="text-gray-600">Passing:</span>
                        <span className="font-medium text-green-600">{test.passing_marks} marks</span>
                      </div>
                    </div>

                    <Link to={`/student/test/${test.id}`}>
                      <Button className="w-full bg-red-600 hover:bg-red-700 mt-4">
                        <FileText className="mr-2" size={16} />
                        Start Test
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default StudentTests;
